import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { DEFAULT_ERROR_MESSAGE, MODAL_MESSAGE_ERROR, MODAL_TYPE_ERROR } from "../HistoriografijaConstants";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [openModal, setOpenModal] = useState(false);
  const [modalName, setModalName] = useState("")
  const [sessionExpired, setSessionExpired] = useState(false)
  const [modalMessage, setModalMessage] = useState("")
  const [modalDescription, setModalDescription] = useState("")
  const [modalType, setModalType] = useState("")
  const [handleDelete, setHandleDelete] = useState(null)

  const displayGenericErrorModal = useCallback(() => {
    setOpenModal(true)
    setModalName("messageModal")
    setModalMessage(MODAL_MESSAGE_ERROR)
    setModalDescription(DEFAULT_ERROR_MESSAGE)
    setModalType(MODAL_TYPE_ERROR)
  }, [setOpenModal, setModalName, setModalMessage, setModalDescription, setModalType])

  const resetModalContext = useCallback(() => {
    setOpenModal(false)
    setModalName("")
    setSessionExpired(false)
    setModalMessage("")
    setModalDescription("")
    setModalType("")
    setHandleDelete(null)
  }, [setOpenModal, setModalName, setModalMessage, setModalDescription, setModalType, setSessionExpired, setHandleDelete])

  const displayMessageModalWithParameters = useCallback((modalMessage, modalDescription, modalType) => {
    setOpenModal(true)
    setModalName("messageModal")
    setModalMessage(modalMessage)
    setModalDescription(modalDescription)
    setModalType(modalType)
  }, [setOpenModal, setModalName, setModalMessage, setModalDescription, setModalType])

  const displayModalWithParameters = useCallback((modalName, modalMessage, modalDescription, modalType, handleDelete) => {
    setOpenModal(true)
    setModalName(modalName)
    setModalMessage(modalMessage)
    setModalDescription(modalDescription)
    setModalType(modalType)
    setHandleDelete(() => handleDelete)
  }, [setOpenModal, setModalName, setModalMessage, setModalDescription, setModalType, setHandleDelete])

  const displayPrijavaModal = useCallback(() => {
    setOpenModal(true)
    setModalName("prijava")
  }, [setOpenModal, setModalName])

  const displayCustomNameModal = useCallback((name) => {
    setOpenModal(true)
    setModalName(name)
  }, [setOpenModal, setModalName])

  const value = useMemo(() => {
    return {openModal, modalName, sessionExpired, modalMessage, modalDescription, modalType, displayGenericErrorModal, 
      resetModalContext, displayMessageModalWithParameters, displayModalWithParameters, handleDelete, displayPrijavaModal, displayCustomNameModal}
  }, [openModal, modalName, sessionExpired, modalMessage, modalDescription, modalType, displayGenericErrorModal, 
    resetModalContext, displayMessageModalWithParameters, displayModalWithParameters, handleDelete, displayPrijavaModal, displayCustomNameModal])

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
}

export const useModalContext = () => {
  return useContext(ModalContext);
}